<template>
  <TableList
    v-rect-loading="loading"
    row-key="id"
    class="offer-letter-template-field-list"
    :title="$t(`${i18nPrefix}.title.offerLetterTemplateFieldList`)"
    :listData="templateFieldList"
    :tableColumns="tableColumns"
    :actionBtn="actionBtn"
    :createBtnLabel="$t(`${i18nPrefix}.btn.add`)"
    @create="handleCreateTemplateField"
  >
    <template #isEnabled="{ data, row }">
      <el-switch v-if="!row.is_default" :value="data" @change="onStatusChange($event, row)"></el-switch>
    </template>
  </TableList>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'

export default {
  components: {
    TableList
  },
  props: {

  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.offerLetterInviteRecordManagement',
      templateFieldList: [],
      actionBtn: {
        edit: {
          show: (row) => row.can_edit,
          onclick: this.handleEditTemplateField
        }
      }
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.templateFieldCnName`),
          dataKey: 'name_cn'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.templateFieldEnName`),
          dataKey: 'name_en'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.templateFieldCreateType`),
          dataKey: 'is_default',
          formatter: (data, row) => {
            return this.$t(`${this.i18nPrefix}.label.${data ? 'systemTemplateField' : 'hrCreateTemplateField'}`)
          }
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.templateFieldValueType`),
          dataKey: 'value_type',
          formatter: (data, row) => {
            return this.$t(`${this.i18nPrefix}.OFFER_LETTER_TEMPLATE_FIELD_TYPE.${data}`)
          }
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.templateFieldType`),
          dataKey: 'type',
          formatter: (data, row) => {
            if (data === 'HR') {
              return this.$t(`${this.i18nPrefix}.label.templateFieldHR`)
            } else if (data === 'CANDIDATE') {
              return this.$t(`${this.i18nPrefix}.label.templateFieldCandidate`)
            }
          }
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.templateFieldStatus`),
          dataKey: 'is_enabled',
          formatter: (data, row) => {
            if (row.is_default) {
              return
            }
            return data
          },
          slotName: 'isEnabled'
        }
      ]
      return columns
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('offerLetter', ['getOfferLetterTemplateFieldList', 'updateOfferLetterTemplateField', 'moveTemplateFieldOrder']),
    initPage () {
      this.loadTemplateFiledList()
    },
    async loadTemplateFiledList () {
      this.loading = true
      try {
        const resp = await this.getOfferLetterTemplateFieldList()
        if (resp) {
          this.templateFieldList = _.orderBy(resp, ['is_default'], ['asc'])
        }
      } finally {
        this.loading = false
      }
    },
    handleCreateTemplateField () {
      this.$router.push('/v-admin/offer-letter-management/field/add')
    },
    handleEditTemplateField (row) {
      this.$router.push(`/v-admin/offer-letter-management/field/edit/${row.id}`)
    },
    async onStatusChange (status, row) {
      const fieldInfo = row
      fieldInfo.is_enabled = status
      this.loading = true
      try {
        const resp = await this.updateOfferLetterTemplateField(fieldInfo)
        if (resp) {
          this.$message.success(this.$t('common.message.optionSuccess'))
        }
        this.loadTemplateFiledList()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.offer-letter-template-field-list {
  .drag-btn {
    .draggable-handle {
      cursor: pointer;
    }
  }
}
</style>
